import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { validatable } from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonPhongBanThuocCoQuan extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
      let params = {
        phongBanHienTaiId: userInfo.coQuanQuanLyId
      };
      DuLieuHeThong.actions.getPhongBanThuocCoQuan.request(params).then(res => {
        let data = res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : [];
        if (this.props.isOther === true) {
          data = data.filter(item => item.coQuanQuanLyId !== this.props.phongBanGiaiQuyet)
        }
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'phongBanThuocCoQuan',
            data
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown
        bindValidator={this}
        channel="formTaoDon"
        isValid={this.props.isValid}
        require={this.props.require}
        className={this.props.className}
        label={this.props.label}
        options={this.state.data}
        keyName='coQuanQuanLyId'
        valueName='ten'
        onChange={this.onChange.bind(this)}
        placeholder={this.props.placeholder}
        selectedValue={this.props.selectedValue}
        name={this.props.name}/>
    )
  }
}

DropDownChonPhongBanThuocCoQuan.defaultProps = {
  label: "Phòng ban",
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name:'',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.phongBanThuocCoQuan
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonPhongBanThuocCoQuan));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonphongbanthuoccoquan.jsx